<script>
export default {
  name: 'Input',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 100,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    spinButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input_value: this.value,
      curr_input_value: this.value,
    }
  },
  watch: {
    value: {
      handler(new_val) {
        this.input_value = new_val
        this.curr_input_value = new_val
      },
    },
  },
  methods: {
    updateInput() {
      if (this.input_value === this.curr_input_value) {
        return
      }
      if (this.$refs.input.valid) {
        const payload = {
          label: this.label,
          value: this.type === 'number' ? Number(this.input_value) : this.input_value,
        }
        this.$emit('update-input', payload)
      } else {
        this.input_value = this.type === 'number' ? Number(this.curr_input_value) : this.curr_input_value
      }
    },
    triggerEnter() {
      this.$refs.input.blur()
    },
    triggerSpinButtons(type) {
      if (type === '-') {
        this.input_value = Number(this.input_value) - 1
      } else if (type === '+') {
        this.input_value = Number(this.input_value) + 1
      }

      this.updateInput()
    },
  },
}
</script>

<template>
  <div class="d-flex" :style="`width: ${width}%`">
    <v-text-field
      ref="input"
      v-model="input_value"
      dense
      outlined
      hide-spin-buttons
      color="primary"
      hide-details="auto"
      :type="type"
      :label="label"
      :disabled="disabled"
      :rules="rules"
      @keyup.enter="triggerEnter()"
      @blur="updateInput"
    />
    <div v-if="spinButtons" class="d-flex align-center ml-3" style="gap: 12px">
      <v-btn class="pa-1" x-small color="primary" min-width="auto" height="auto" @click="triggerSpinButtons('-')">
        <v-icon small v-text="'mdi-minus'" />
      </v-btn>
      <v-btn class="pa-1" x-small color="primary" min-width="auto" height="auto" @click="triggerSpinButtons('+')">
        <v-icon small v-text="'mdi-plus'" />
      </v-btn>
    </div>
  </div>
</template>
